export default __webpack_public_path__ + "static/media/hub-public-key.2f690378.svg";